module.exports = __webpack_public_path__ + "media/images/icon-pinterest-5dc92ce4524ecada9c7166ceb523fcad.svg";